import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import styled from 'App/styled';
import Button, { KIND, SIZE, SHAPE } from '@nykaa/ui-components/Button';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import Sort from 'components/ListingFilters/ListingSort';
import SelectedFilters from 'components/ListingFilters/SelectedFilters';
import Filters from './Filters';
import { getSortOption, forFilterChange, forSortChange, getStoreName } from '../mapItems';
import { filterListingIdName } from '../Scroll/constants';
import { State } from 'store/types';
import { PRICE_RANGE_LISTING_DISMISS, PRICE_RANGE_LISTING_ERROR } from '../../../constants';


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 270px;
  color: ${({ theme }) => theme.colors.textPrimary};
  #filter-sort {
    margin-bottom: 16px;
  }
  .is-affixed {
    .sidebar__inner {
      bottom: 30px;
      width: 270px;
    }
  }
`;

interface Props {
  isSearch: boolean;
}

const FiltersAndSort = ({ isSearch }: Props) => {
  const storeName = getStoreName(isSearch);
  const sortOptions = getSortOption(isSearch);
  const listingPage = useSelector((state: State) => state[storeName], shallowEqual);
  const pageName = useSelector((state: State) => state.dataLayer.listingPageType);
  const pageTitle = useSelector((state: State) => state.dataLayer.pageTitle);
  const dispatch = useDispatch();
  const { listingData, activeFilters = {}, isEmptyRangeError, loading } = listingPage || {};
  const { filters = [], sort: activeSort = '' } = listingData || {};
  const [showRangeToast, setShowRangeToast] = useState(false);
  const { dynamicPriceRangeToastConfig } = useSelector((state: State) => state.remoteConfig?.configs);
  const { enabled = true, timer = 4 } = dynamicPriceRangeToastConfig || {};
  const changeSortAction = useCallback(
    params => {
      dispatch(forSortChange(isSearch)(params));
    },
    [dispatch, isSearch]
  );
  const changeFilterAction = useCallback(
    (params, isClearAll) => {
      dispatch(forFilterChange(isSearch)(params, isClearAll));
    },
    [dispatch, isSearch]
  );

  useEffect(() => {
    if (isEmptyRangeError && activeFilters.price_range_filter && !loading) {
      const updatedFilters = { ...activeFilters };
      delete updatedFilters.price_range_filter;
      changeFilterAction(updatedFilters, false);
      setShowRangeToast(true);
    }
  }, [activeFilters, changeFilterAction, isEmptyRangeError, loading]);


  return (
    <>
      <Wrapper id={filterListingIdName}>
        <SelectedFilters activeFilters={activeFilters} changeFilter={changeFilterAction} />
        <div id="filter-sort">
          <Sort pageName={pageName} pageTitle={pageTitle} activeSort={activeSort} sortOptions={sortOptions} changeSort={changeSortAction} />
        </div>
        <Filters pageName={pageName} pageTitle={pageTitle} activeFilters={activeFilters} filters={filters} changeFilter={changeFilterAction} isSearch={isSearch} />
      </Wrapper>
      {
        (showRangeToast && enabled) && (
          <Toast
            hideTimer
            verticalOffset={60}
            message={PRICE_RANGE_LISTING_ERROR}
            onDismiss={() => setShowRangeToast(false)}
            timer={timer}
            variant={VARIANT.single}
          >
            <Button
              kind={KIND.tertiary}
              size={SIZE.small}
              shape={SHAPE.default}
              onClick={() => setShowRangeToast(false)}
            >
              {PRICE_RANGE_LISTING_DISMISS}
            </Button>
          </Toast>
        )
      }
    </>

  );
};

export default FiltersAndSort;
